import axios from '../index';

// export const getcustomertabledata = async (signal) => {
//   return axios.get(`api/managesettingreporting/`, {
//     withCredentials: true,
//     signal: signal
//   });
// };

// export const updatereportingtabledata = async (params) => {
//   return axios.post(
//     `api/managesettingreporting/`,
//     params,
//     { data: { weightage: updatedlists } },
//     {
//       withCredentials: true
//     }
//   );
// };

export const getReportingData = async ({ id }) => {
  return axios.get(`api/elastic/settings_reporting/?team_id=${id}`);
};

export const updateReportingData = async (params, signal) => {
  return axios.put(`api/elastic/settings_reporting/update_sop_reporting_data/?team_id=${params.team_id}`, params, { signal: signal });
};

export const getAllTeams = () => {
  return axios.get(`api/team/team/?get_all=true`);
};
